export default __webpack_public_path__ + "static/DIN-Regular-7a37a303cdc41fb9ccffbac896df442e.otf";